/** Sources screen tabs: Origins and the review queue (EN source of truth + VI); spread into the main dictionaries */

export const sourcesTabsEn = {
  'sources.tabs': 'Sources views',
  'sources.tab.origins': 'Origins',
  'sources.tab.review': 'Waiting for the wiki',
} satisfies Record<string, string>

export const sourcesTabsVi: Record<keyof typeof sourcesTabsEn, string> = {
  'sources.tabs': 'Các chế độ xem Nguồn',
  'sources.tab.origins': 'Nguồn gốc',
  'sources.tab.review': 'Chờ vào Wiki',
}
